<template>
  <div>
    <div class="separator-big"></div>
    <div class="title">Privacy Policy</div>
    <div class="separator-small"></div>
    <div class="container">
      <span>Last Update: 02.10.2025</span>
    </div>
    <div class="container">
      <div class="separator-big"></div>
      <div class="sub-title">Information Collection</div>
      <div class="separator-small"></div>
      <div class="content">
        <div>
          <b
            >We do not collect any information that is related to you or the
            devices on which you have installed our games & apps.</b
          >
        </div>
        We are not using Notifications, Cookies or
        any other sort of tracking services.
        <div class="separator-big"></div>
        <h2>Third-Party Services</h2>
  <p>Our apps & games integrate with third-party services to support advertising and analytics. These services may collect limited, anonymized data from your device, such as:</p>
  <ul>
    <li>Device type and operating system</li>
    <li>App usage data</li>
    <li>General location (approximate)</li>
    <li>Advertising identifiers</li>
  </ul>

  <p>The following third-party services are used:</p>

  <h3>Google AdMob</h3>
  <p>We use Google AdMob to display ads in the games & apps. AdMob may show personalized or non-personalized ads based on your consent. You can learn more about their data usage here:</p>
  <p><a href="https://policies.google.com/technologies/ads" target="_blank">Google AdMob Privacy Policy</a></p>

  <h3>Facebook SDK</h3>
  <p>Some features of our apps & games may use Facebook SDK. This service may collect information such as device identifiers and usage statistics. For more information, see:</p>
  <p><a href="https://www.facebook.com/about/privacy" target="_blank">Facebook Privacy Policy</a></p>

  <h2>User Choices</h2>
  <p>We respect your choices regarding data collection. You may:</p>
  <ul>
    <li>Use iOS "Ask App Not to Track" to limit tracking</li>
    <li>Disable personalized ads (via consent popups)</li>
    <li>Opt-out of data collection by configuring device settings</li>
  </ul>

  <h2>Children's Privacy</h2>
  <p>Our apps & games do not knowingly collect data from children under the age of 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us.</p>
        <div class="separator-big"></div>
        <p class="sub-title-bold">In-App Purchase Terms</p>
        <div class="separator-xs"></div>
        We use Apple’s billing software to process In App purchases from our Games & Apps
        made through the App Store. As a result, when making your purchase
        from our games & apps through the App Store, you will be asked to
        provide personal information to Apple, such as your app store password (or Face ID) for billing purposes. This information is
        collected by Apple in order for them to validate the purchase.
        <b>It is neither collected nor used by us</b>.
        <div class="separator-big"></div>
        <p class="sub-title-bold">Data Retention</p>
        <div class="separator-xs"></div>
        <b>We do not retain any of your data as we do not collect any data from you</b>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.container {
  text-align: left;
  padding: 10px 30px;
}
.title {
  font-family: "Roboto Condensed";
  font-size: 50px;
  margin: 0;
}

.sub-title {
  font-family: "Roboto Condensed";
  font-size: 40px;
  margin: 0;
}

.sub-title-bold {
  font-family: "Roboto Condensed";
  font-size: 25px;
  font-weight: bold;
  margin: 0;
}

.content {
  font-family: "Roboto Condensed";
  font-size: 22px;
  margin: 0;
}

.separator {
  &-big {
    height: 30px;
  }
  &-small {
    height: 18px;
  }
  &-xs {
    height: 13px;
  }
}
</style>
